import { eventEmitter } from '@/lib/eventEmitter.ts';
import { syncToWebViewAction } from '@/actions/sync/SyncToWebViewAction.ts';
import { SYNC_TO_WEB_VIEW_KEYS } from '@/types/sync/SyncKeys.ts';

export const showScreenshotPreviewAction = (
    screenCaptureData: string | undefined,
    screenCaptureCount: number,
) => {
    eventEmitter.emit('showScreenCapturePreview', {
        screenCaptureData,
        screenCaptureCount,
    });

    syncToWebViewAction(
        SYNC_TO_WEB_VIEW_KEYS.showSolvePreview,
        JSON.stringify({ screenCaptureData, screenCaptureCount }),
    );
};
